module.exports = __webpack_public_path__ + "img/xm.35617cfe.svg";